import { isUltimate } from '@merchant-backend/util'
import { getProText, getProTitle } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styles from './style.module.less'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { video, coupon, detail, pay_money } = store

    const { coupon_type, gift_day, rest_day } = coupon || {}
    const { pro_date } = detail || {}
    const {
      pay_fee, // 支付金额
      fee // 原价
    } =
      pay_money || {}

    let buttonStyle = {
      minWidth: 100,
      marginRight: 20
    }

    const _isUltimate = isUltimate()

    return (
      <div className={styles.desWrap}>
        <div style={{ width: 144, height: 144 }}>
          <img
            src="http://qnm.hunliji.com/o_1c3hgpepouv4qglnc1cl713ocp.png"
            alt=""
          />
        </div>
        <div className={styles.text}>
          <p className={styles.title}>{getProTitle()}</p>
          <p className={styles.description}>{getProText()}</p>
          {fee && (
            <div>
              <p className={styles.servicePrice}>
                <span className={styles.serviceLabel}>服务价格：</span>
                <span className={styles.price}>
                  <i>{'¥' + pay_fee}</i>/年
                </span>
                {coupon_type && (
                  <span className={styles.fee}>原价: ￥{fee}</span>
                )}
              </p>
              {coupon_type &&
                (coupon_type == 2 ? (
                  <span className={styles.coupon}>
                    您已有一张限时优惠券，
                    <span className={styles['coupon-desc']}>
                      多送{gift_day}天
                    </span>
                    ，还剩{rest_day}天过期
                  </span>
                ) : (
                  <span className={styles.coupon}>
                    您已有一张限时优惠券，
                    <span className={styles['coupon-desc']}>
                      仅需{pay_fee}元
                    </span>
                    ，还剩{rest_day}天过期
                  </span>
                ))}
              <p className={styles.mt16}>
                <Button
                  type="primary"
                  style={buttonStyle}
                  onClick={store.bookService(
                    `购买${getProTitle()}`,
                    fee,
                    !_isUltimate ? 'no_pro_top' : 'pro_top'
                  )}
                >
                  {!_isUltimate ? '立即订购' : '立即续费'}
                </Button>
                {fee &&
                  _isUltimate && (
                    <span
                      className={styles.bought}
                    >{`已开通 有效期至${pro_date}`}</span>
                  )}
              </p>
            </div>
          )}
        </div>
        {video &&
          video.cover_path && (
            <div className={styles.videoBox}>
              <video
                muted="muted"
                autoPlay
                // controls={false}
                playsInline
                loop
                src={video.cover_path}
                type="video/mp4"
                className={styles.minVideo}
              />
              <div
                className={styles.videoBg}
                style={{
                  backgroundImage: `url(${video.image_path})`
                }}
              >
                <img
                  className={styles.videoIcon}
                  src="https://qnm.hunliji.com/o_1d0jjjfglbdf1bdma9h12tdrv89.png"
                  onClick={store.changeVideoModal(true)}
                />
                <div className={styles.btnGroupBg} />
              </div>
            </div>
          )}
      </div>
    )
  }
}
